/* eslint-disable no-nested-ternary */
import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { Box, CircularProgress, makeStyles, Typography } from '@material-ui/core';
import { context } from '../../../../../globalState/GlobalState';
import { getOptimXForegroundStyle } from '../../../../../catalog/Website';

const circularProgressStyle = makeStyles((theme) => {
    return {
        root: {
            position: 'relative',
        },
        bottom: {
            color: theme.palette.grey[300],
        },
        top: {
            position: 'absolute',
            left: 0,
        },
        circle: {
            strokeLinecap: 'round',
        },
    };
});

const CustomCircularProgress = (props) => {
    const { size, thickness, value, style } = props;
    const classes = circularProgressStyle();

    return (
        <div className={classes.root}>
            <CircularProgress
                variant="determinate"
                className={classes.bottom}
                size={size}
                thickness={thickness}
                value={100}
            />
            <CircularProgress
                variant="determinate"
                disableShrink
                className={classes.top}
                classes={{
                    circle: classes.circle,
                }}
                size={size}
                thickness={thickness}
                value={value}
                style={style}
            />
        </div>
    );
};

CustomCircularProgress.propTypes = {
    size: PropTypes.number.isRequired,
    thickness: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
    style: PropTypes.object.isRequired,
};

const CircularProgressWithLabel = (props) => {
    const { title, value, maxValue, isPercentage, justifyContent } = props;
    const { globalState } = useContext(context);

    const getValue = () => {
        const statNumber = Number(value);
        if (statNumber === 0) return 0;
        if (statNumber === Number.POSITIVE_INFINITY) return 0;
        if (statNumber === Number.NEGATIVE_INFINITY) return 0;
        if (Number.isNaN(statNumber)) return 0;
        return statNumber.toString();
    };

    return (
        <div className="circular-progress m-t-25px m-b-25px" style={{ justifyContent }}>
            <Box position="relative" display="inline-flex">
                <CustomCircularProgress
                    variant="determinate"
                    style={getOptimXForegroundStyle(globalState)}
                    value={(100 * getValue(value)) / maxValue}
                    size={70}
                    thickness={5}
                />
                <Box
                    top={0}
                    left={0}
                    bottom={0}
                    right={0}
                    position="absolute"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Typography className="font-size-m font-weight-800" variant="caption" component="p">
                        {value > 999999999 ? (isPercentage ? `${0}%` : 0) : (isPercentage ? `${getValue(value)}%` : value)}
                    </Typography>
                </Box>
            </Box>
            <p className="font-size-l text-capitalize m-l-20px text-left-align">
                {title}
            </p>
        </div>
    );
};

CircularProgressWithLabel.propTypes = {
    title: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    maxValue: PropTypes.number.isRequired,
    isPercentage: PropTypes.bool,
    justifyContent: PropTypes.string,
};

CircularProgressWithLabel.defaultProps = {
    isPercentage: false,
    justifyContent: 'flex-start',
};

export default memo(CircularProgressWithLabel);
